/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const ROUTES = {
  accounts: {
    index: "/accounts",
    details: "/accounts/:id",
    create: "/accounts/create",
  },
  organizations: {
    index: "/organizations",
    details: "/organizations/:id",
    create: "/organizations/create",
  },
  index: "/",
  notFound: "/404",
  api: "/graphql",
};
